import { DefaultQueryParams, environmentBuilder, parseQuery } from '@pascal/pascal-core';
import { gameName } from '../enums/gameConfigsAndUrls';
import { favoriteBetsService } from '../services/favoriteBetService';
import { action, flow, makeObservable, observable, toJS } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

const { httpUrl: url } = environmentBuilder(gameName);

class FavoriteBetsStore {
  favoriteBets = [];

  constructor() {
    makeObservable(this, {
      favoriteBets: observable,
      setFavoriteBes: action.bound,
      addFavoriteBet: flow,
      getFavoriteBets: flow,
      editFavoriteBet: flow,
      deleteFavoriteBet: flow,
    });
  }

  setFavoriteBes(favoriteBets) {
    this.favoriteBets = favoriteBets;
  }

  *deleteFavoriteBet(data) {
    yield favoriteBetsService.deleteFavoriteBets(data);
    yield this.getFavoriteBets();
  }

  *editFavoriteBet(data) {
    yield favoriteBetsService.ediFavoriteBets(data);
    yield this.getFavoriteBets();
  }

  *addFavoriteBet(data) {
    yield favoriteBetsService.addFavoriteBet(data);
    yield this.getFavoriteBets();
  }

  *getFavoriteBets() {
    const { gameTypeId } = gameConfigStore;
    const {
      data: { result },
    } = yield favoriteBetsService.getFavoriteBetsByGameTypeId(gameTypeId);
    this.favoriteBets = result;
  }
}

export const favoriteBetsStore = new FavoriteBetsStore();
